import Form from '../../views/Banner/Form';
import { __ADMINISTRADOR, __CENTRAL } from '../../security/RoleConfiguration';

export const path = '/admin/banners';

export const listRoutes = [
    {
        path: path + '/adicionar',
        component: Form,
        roles: [ __ADMINISTRADOR, __CENTRAL ],
    },
    {
        path: path + '/:id/editar',
        component: Form,
        roles: [ __ADMINISTRADOR, __CENTRAL ],
    }
];

export default listRoutes;